import type { State } from '@/state';
import type { FilterOption } from './option';
import { getFilterAllOption } from './function';

interface MetroFilter {
    id: number;
    name: string;
    lat: string,
    lng: string,
    child: StationFilter[]
}

interface StationFilter {
    id: number,
    name: string,
    lat: string,
    lng: string
}

interface MetroMap {
    regionName: string,
    regionId: number,
    metroLineIds: number[]
}

const METRO: MetroFilter[] = [{
    id: 100,
    name: "文湖線",
    lat: "25.0416040",
    lng: "121.5437750",
    child: [{
        id: 4257,
        name: "南港展覽館",
        lat: "25.0552650",
        lng: "121.6173590"
    }, {
        id: 4314,
        name: "南港軟體園區",
        lat: "25.0595760",
        lng: "121.6159210"
    }, {
        id: 4315,
        name: "東湖",
        lat: "25.0671810",
        lng: "121.6114790"
    }, {
        id: 4316,
        name: "葫洲",
        lat: "25.0727900",
        lng: "121.6070030"
    }, {
        id: 4317,
        name: "大湖公園",
        lat: "25.0837440",
        lng: "121.6023380"
    }, {
        id: 4318,
        name: "內湖",
        lat: "25.0837830",
        lng: "121.5945520"
    }, {
        id: 4319,
        name: "文德",
        lat: "25.0785300",
        lng: "121.5847270"
    }, {
        id: 4320,
        name: "港墘",
        lat: "25.0800440",
        lng: "121.5751010"
    }, {
        id: 4321,
        name: "西湖",
        lat: "25.0821500",
        lng: "121.5671430"
    }, {
        id: 4282,
        name: "劍南路",
        lat: "25.0848000",
        lng: "121.5558750"
    }, {
        id: 4323,
        name: "大直",
        lat: "25.0794919",
        lng: "121.5469110"
    }, {
        id: 4324,
        name: "松山機場",
        lat: "25.0629100",
        lng: "121.5521900"
    }, {
        id: 4185,
        name: "中山國中",
        lat: "25.0608340",
        lng: "121.5441830"
    }, {
        id: 4186,
        name: "南京復興",
        lat: "25.0525280",
        lng: "121.5440670"
    }, {
        id: 4187,
        name: "忠孝復興",
        lat: "25.0416040",
        lng: "121.5437750"
    }, {
        id: 4188,
        name: "大安",
        lat: "25.0329920",
        lng: "121.5435820"
    }, {
        id: 4189,
        name: "科技大樓",
        lat: "25.0261190",
        lng: "121.5434370"
    }, {
        id: 4190,
        name: "六張犁",
        lat: "25.0237870",
        lng: "121.5531280"
    }, {
        id: 4191,
        name: "麟光",
        lat: "25.0185250",
        lng: "121.5587720"
    }, {
        id: 4192,
        name: "辛亥",
        lat: "25.0054780",
        lng: "121.5571030"
    }, {
        id: 4193,
        name: "萬芳醫院",
        lat: "24.9993490",
        lng: "121.5580850"
    }, {
        id: 4194,
        name: "萬芳社區",
        lat: "24.9985620",
        lng: "121.5680980"
    }, {
        id: 4195,
        name: "木柵",
        lat: "24.9982340",
        lng: "121.5731460"
    }, {
        id: 4196,
        name: "動物園",
        lat: "24.9982650",
        lng: "121.5794760"
    }]
}, {
    id: 125,
    name: "淡水信義線",
    lat: "25.0622190",
    lng: "121.5196140",
    child: [{
        id: 4198,
        name: "新北投",
        lat: "25.1369380",
        lng: "121.5025330"
    }, {
        id: 4163,
        name: "淡水",
        lat: "25.1679890",
        lng: "121.4455130"
    }, {
        id: 4164,
        name: "紅樹林",
        lat: "25.1548020",
        lng: "121.4588300"
    }, {
        id: 4165,
        name: "竹圍",
        lat: "25.1373690",
        lng: "121.4598230"
    }, {
        id: 4166,
        name: "關渡",
        lat: "25.1257790",
        lng: "121.4671340"
    }, {
        id: 4167,
        name: "忠義",
        lat: "25.1315510",
        lng: "121.4733840"
    }, {
        id: 4168,
        name: "復興崗",
        lat: "25.1379610",
        lng: "121.4888120"
    }, {
        id: 4169,
        name: "北投",
        lat: "25.1318340",
        lng: "121.4983650"
    }, {
        id: 4170,
        name: "奇岩",
        lat: "25.1252870",
        lng: "121.5011280"
    }, {
        id: 4171,
        name: "唭哩岸",
        lat: "25.1208790",
        lng: "121.5062460"
    }, {
        id: 4172,
        name: "石牌",
        lat: "25.1145210",
        lng: "121.5155500"
    }, {
        id: 4173,
        name: "明德",
        lat: "25.1096560",
        lng: "121.5189190"
    }, {
        id: 4174,
        name: "芝山",
        lat: "25.1030550",
        lng: "121.5225110"
    }, {
        id: 4175,
        name: "士林",
        lat: "25.0935290",
        lng: "121.5262170"
    }, {
        id: 4176,
        name: "劍潭",
        lat: "25.0843370",
        lng: "121.5250210"
    }, {
        id: 4177,
        name: "圓山",
        lat: "25.0716410",
        lng: "121.5201180"
    }, {
        id: 4178,
        name: "民權西路",
        lat: "25.0622190",
        lng: "121.5196140"
    }, {
        id: 4179,
        name: "雙連",
        lat: "25.0577970",
        lng: "121.5206650"
    }, {
        id: 4180,
        name: "中山",
        lat: "25.0526360",
        lng: "121.5203700"
    }, {
        id: 4181,
        name: "台北車站",
        lat: "25.0462700",
        lng: "121.5175050"
    }, {
        id: 4182,
        name: "台大醫院",
        lat: "25.0421970",
        lng: "121.5163200"
    }, {
        id: 4183,
        name: "中正紀念堂",
        lat: "25.0339300",
        lng: "121.5173820"
    }, {
        id: 4200,
        name: "東門",
        lat: "25.0338845",
        lng: "121.5284819"
    }, {
        id: 4201,
        name: "大安森林公園",
        lat: "25.0335989",
        lng: "121.5351496"
    }, {
        id: 4188,
        name: "大安",
        lat: "25.0329920",
        lng: "121.5435820"
    }, {
        id: 66300,
        name: "信義安和",
        lat: "25.0332827",
        lng: "121.5524300"
    }, {
        id: 66301,
        name: "台北101/世貿",
        lat: "25.0329368",
        lng: "121.5628530"
    }, {
        id: 4205,
        name: "象山",
        lat: "25.0329121",
        lng: "121.5693137"
    }]
}, {
    id: 195,
    name: "新北投支線",
    lat: "25.1369380",
    lng: "121.5025330",
    child: [{
        id: 4169,
        name: "北投",
        lat: "25.1318340",
        lng: "121.4983650"
    }, {
        id: 4198,
        name: "新北投",
        lat: "25.1369380",
        lng: "121.5025330"
    }]
}, {
    id: 148,
    name: "松山新店線",
    lat: "25.0422280",
    lng: "121.5083110",
    child: [{
        id: 4235,
        name: "松山",
        lat: "25.0501397",
        lng: "121.5781343"
    }, {
        id: 4236,
        name: "南京三民",
        lat: "25.0515122",
        lng: "121.5639883"
    }, {
        id: 66305,
        name: "台北小巨蛋",
        lat: "25.0517392",
        lng: "121.5516207"
    }, {
        id: 4186,
        name: "南京復興",
        lat: "25.0525280",
        lng: "121.5440670"
    }, {
        id: 66266,
        name: "松江南京",
        lat: "25.0520698",
        lng: "121.5327819"
    }, {
        id: 4180,
        name: "中山",
        lat: "25.0526360",
        lng: "121.5203700"
    }, {
        id: 4241,
        name: "北門",
        lat: "25.0501713",
        lng: "121.5103855"
    }, {
        id: 4242,
        name: "西門",
        lat: "25.0422280",
        lng: "121.5083110"
    }, {
        id: 4255,
        name: "小南門",
        lat: "25.0355920",
        lng: "121.5107840"
    }, {
        id: 4183,
        name: "中正紀念堂",
        lat: "25.0339300",
        lng: "121.5173820"
    }, {
        id: 4184,
        name: "古亭",
        lat: "25.0270570",
        lng: "121.5223660"
    }, {
        id: 4244,
        name: "台電大樓",
        lat: "25.0204950",
        lng: "121.5283310"
    }, {
        id: 4245,
        name: "公館",
        lat: "25.0147680",
        lng: "121.5342910"
    }, {
        id: 4246,
        name: "萬隆",
        lat: "25.0019100",
        lng: "121.5390330"
    }, {
        id: 4247,
        name: "景美",
        lat: "24.9925600",
        lng: "121.5406310"
    }, {
        id: 4248,
        name: "大坪林",
        lat: "24.9830010",
        lng: "121.5414040"
    }, {
        id: 4249,
        name: "七張",
        lat: "24.9750210",
        lng: "121.5430670"
    }, {
        id: 4251,
        name: "新店區公所",
        lat: "24.9677900",
        lng: "121.5414570"
    }, {
        id: 4250,
        name: "新店",
        lat: "24.9575190",
        lng: "121.5375310"
    }, {
        id: 4253,
        name: "小碧潭",
        lat: "24.9718600",
        lng: "121.5304100"
    }]
}, {
    id: 192,
    name: "小碧潭支線",
    lat: "24.9718600",
    lng: "121.5304100",
    child: [{
        id: 4253,
        name: "小碧潭",
        lat: "24.9718600",
        lng: "121.5304100"
    }, {
        id: 4249,
        name: "七張",
        lat: "24.9750210",
        lng: "121.5430670"
    }]
}, {
    id: 162,
    name: "中和新蘆線",
    lat: "25.0520698",
    lng: "121.5327819",
    child: [{
        id: 66258,
        name: "蘆洲",
        lat: "25.0917625",
        lng: "121.4639818"
    }, {
        id: 66259,
        name: "三民高中",
        lat: "25.0854674",
        lng: "121.4733363"
    }, {
        id: 66260,
        name: "徐匯中學",
        lat: "25.0807711",
        lng: "121.4795041"
    }, {
        id: 66261,
        name: "三和國中",
        lat: "25.0768671",
        lng: "121.4862494"
    }, {
        id: 66262,
        name: "三重國小",
        lat: "25.0702588",
        lng: "121.4970673"
    }, {
        id: 4207,
        name: "迴龍",
        lat: "25.0223802",
        lng: "121.4122956"
    }, {
        id: 4208,
        name: "丹鳳",
        lat: "25.0289433",
        lng: "121.4220879"
    }, {
        id: 4209,
        name: "輔大",
        lat: "25.0328224",
        lng: "121.4356373"
    }, {
        id: 4210,
        name: "新莊",
        lat: "25.0360967",
        lng: "121.4517618"
    }, {
        id: 4211,
        name: "頭前庄",
        lat: "25.0397140",
        lng: "121.4615264"
    }, {
        id: 4212,
        name: "先嗇宮",
        lat: "25.0465075",
        lng: "121.4716406"
    }, {
        id: 4213,
        name: "三重",
        lat: "25.0558033",
        lng: "121.4838470"
    }, {
        id: 4214,
        name: "菜寮",
        lat: "25.0596624",
        lng: "121.4908597"
    }, {
        id: 4215,
        name: "台北橋",
        lat: "25.0633142",
        lng: "121.5003498"
    }, {
        id: 66263,
        name: "大橋頭",
        lat: "25.0631600",
        lng: "121.5131400"
    }, {
        id: 4178,
        name: "民權西路",
        lat: "25.0622190",
        lng: "121.5196140"
    }, {
        id: 66264,
        name: "中山國小",
        lat: "25.0627700",
        lng: "121.5265000"
    }, {
        id: 66265,
        name: "行天宮",
        lat: "25.0590000",
        lng: "121.5332100"
    }, {
        id: 66266,
        name: "松江南京",
        lat: "25.0520698",
        lng: "121.5327819"
    }, {
        id: 4221,
        name: "忠孝新生",
        lat: "25.0423570",
        lng: "121.5329040"
    }, {
        id: 4200,
        name: "東門",
        lat: "25.0338845",
        lng: "121.5284819"
    }, {
        id: 4184,
        name: "古亭",
        lat: "25.0270570",
        lng: "121.5223660"
    }, {
        id: 4231,
        name: "頂溪",
        lat: "25.0135190",
        lng: "121.5154290"
    }, {
        id: 4232,
        name: "永安市場",
        lat: "25.0025860",
        lng: "121.5109880"
    }, {
        id: 4233,
        name: "景安",
        lat: "24.9939019",
        lng: "121.5050870"
    }, {
        id: 4234,
        name: "南勢角",
        lat: "24.9897210",
        lng: "121.5097700"
    }]
}, {
    id: 168,
    name: "板南線",
    lat: "25.0423570",
    lng: "121.5329040",
    child: [{
        id: 4257,
        name: "南港展覽館",
        lat: "25.0552650",
        lng: "121.6173590"
    }, {
        id: 4258,
        name: "南港",
        lat: "25.0521400",
        lng: "121.6070590"
    }, {
        id: 4259,
        name: "昆陽",
        lat: "25.0504120",
        lng: "121.5932620"
    }, {
        id: 4260,
        name: "後山埤",
        lat: "25.0448650",
        lng: "121.5823700"
    }, {
        id: 4261,
        name: "永春",
        lat: "25.0408769",
        lng: "121.5755860"
    }, {
        id: 4262,
        name: "市政府",
        lat: "25.0411440",
        lng: "121.5659710"
    }, {
        id: 4263,
        name: "國父紀念館",
        lat: "25.0413310",
        lng: "121.5577420"
    }, {
        id: 4264,
        name: "忠孝敦化",
        lat: "25.0414990",
        lng: "121.5505080"
    }, {
        id: 4187,
        name: "忠孝復興",
        lat: "25.0416040",
        lng: "121.5437750"
    }, {
        id: 4221,
        name: "忠孝新生",
        lat: "25.0423570",
        lng: "121.5329040"
    }, {
        id: 4267,
        name: "善導寺",
        lat: "25.0447580",
        lng: "121.5236800"
    }, {
        id: 4181,
        name: "台北車站",
        lat: "25.0462700",
        lng: "121.5175050"
    }, {
        id: 4242,
        name: "西門",
        lat: "25.0422280",
        lng: "121.5083110"
    }, {
        id: 4271,
        name: "龍山寺",
        lat: "25.0352810",
        lng: "121.4998350"
    }, {
        id: 4272,
        name: "江子翠",
        lat: "25.0304790",
        lng: "121.4728090"
    }, {
        id: 4273,
        name: "新埔",
        lat: "25.0234110",
        lng: "121.4681960"
    }, {
        id: 4274,
        name: "板橋",
        lat: "25.0138300",
        lng: "121.4625250"
    }, {
        id: 4275,
        name: "府中",
        lat: "25.0085650",
        lng: "121.4591780"
    }, {
        id: 4277,
        name: "亞東醫院",
        lat: "24.9984430",
        lng: "121.4525580"
    }, {
        id: 4278,
        name: "海山",
        lat: "24.9853060",
        lng: "121.4488190"
    }, {
        id: 4279,
        name: "土城",
        lat: "24.9731510",
        lng: "121.4443400"
    }, {
        id: 4280,
        name: "永寧",
        lat: "24.9667980",
        lng: "121.4363040"
    }, {
        id: 4281,
        name: "頂埔",
        lat: "24.9593915",
        lng: "121.4194736"
    }]
}, {
    id: 238,
    name: "高雄紅線",
    lat: "22.6313980",
    lng: "120.3019600",
    child: [{
        id: 4329,
        name: "小港",
        lat: "22.5648200",
        lng: "120.3538340"
    }, {
        id: 4330,
        name: "高雄國際機場",
        lat: "22.5701259",
        lng: "120.3421350"
    }, {
        id: 4331,
        name: "草衙",
        lat: "22.5803690",
        lng: "120.3284450"
    }, {
        id: 4332,
        name: "前鎮高中",
        lat: "22.5883240",
        lng: "120.3217660"
    }, {
        id: 4333,
        name: "凱旋",
        lat: "22.5968430",
        lng: "120.3151410"
    }, {
        id: 4334,
        name: "獅甲",
        lat: "22.6058810",
        lng: "120.3081990"
    }, {
        id: 4335,
        name: "三多商圈",
        lat: "22.6138489",
        lng: "120.3046160"
    }, {
        id: 4336,
        name: "中央公園",
        lat: "22.6246290",
        lng: "120.3011930"
    }, {
        id: 4337,
        name: "美麗島",
        lat: "22.6313980",
        lng: "120.3019600"
    }, {
        id: 4338,
        name: "高雄車站",
        lat: "22.6396760",
        lng: "120.3026690"
    }, {
        id: 4339,
        name: "後驛",
        lat: "22.6483199",
        lng: "120.3033440"
    }, {
        id: 4340,
        name: "凹子底",
        lat: "22.6572310",
        lng: "120.3030650"
    }, {
        id: 4341,
        name: "巨蛋",
        lat: "22.6662560",
        lng: "120.3033550"
    }, {
        id: 4342,
        name: "生態園區",
        lat: "22.6768340",
        lng: "120.3066760"
    }, {
        id: 4343,
        name: "左營",
        lat: "22.6880250",
        lng: "120.3091760"
    }, {
        id: 4344,
        name: "世運",
        lat: "22.7016150",
        lng: "120.3025130"
    }, {
        id: 4345,
        name: "油廠國小",
        lat: "22.7086170",
        lng: "120.3023090"
    }, {
        id: 4346,
        name: "楠梓加工區",
        lat: "22.7187010",
        lng: "120.3071990"
    }, {
        id: 4347,
        name: "後勁",
        lat: "22.7223490",
        lng: "120.3163320"
    }, {
        id: 4348,
        name: "都會公園",
        lat: "22.7293400",
        lng: "120.3209930"
    }, {
        id: 4349,
        name: "青埔",
        lat: "22.7446730",
        lng: "120.3177050"
    }, {
        id: 4350,
        name: "橋頭糖廠",
        lat: "22.7534640",
        lng: "120.3144920"
    }, {
        id: 4351,
        name: "橋頭火車站",
        lat: "22.7604340",
        lng: "120.3108920"
    }, {
        id: 4352,
        name: "南岡山",
        lat: "22.7808620",
        lng: "120.3016560"
    }]
}, {
    id: 263,
    name: "高雄橘線",
    lat: "22.6313980",
    lng: "120.3019600",
    child: [{
        id: 4353,
        name: "西子灣",
        lat: "22.6215440",
        lng: "120.2745430"
    }, {
        id: 4354,
        name: "鹽埕埔",
        lat: "22.6235100",
        lng: "120.2837500"
    }, {
        id: 4355,
        name: "市議會",
        lat: "22.6290260",
        lng: "120.2948900"
    }, {
        id: 4337,
        name: "美麗島",
        lat: "22.6313980",
        lng: "120.3019600"
    }, {
        id: 4357,
        name: "信義國小",
        lat: "22.6307540",
        lng: "120.3116320"
    }, {
        id: 4358,
        name: "文化中心",
        lat: "22.6302940",
        lng: "120.3175920"
    }, {
        id: 4359,
        name: "五塊厝",
        lat: "22.6295569",
        lng: "120.3276890"
    }, {
        id: 4360,
        name: "技擊館",
        lat: "22.6273280",
        lng: "120.3343240"
    }, {
        id: 4361,
        name: "衛武營",
        lat: "22.6251290",
        lng: "120.3410560"
    }, {
        id: 4362,
        name: "鳳山西",
        lat: "22.6253470",
        lng: "120.3480460"
    }, {
        id: 4363,
        name: "鳳山",
        lat: "22.6259510",
        lng: "120.3553740"
    }, {
        id: 4364,
        name: "大東",
        lat: "22.6253439",
        lng: "120.3633910"
    }, {
        id: 4365,
        name: "鳳山國中",
        lat: "22.6249060",
        lng: "120.3724760"
    }, {
        id: 4366,
        name: "大寮",
        lat: "22.6223800",
        lng: "120.3902800"
    }]
}, {
    id: 307,
    name: "高雄輕軌",
    lat: "22.5936310",
    lng: "120.3105190",
    child: [{
        id: 66386,
        name: "凱旋公園",
        lat: "22.629375",
        lng: "120.322858"
    }, {
        id: 66387,
        name: "衛生局",
        lat: "22.625182",
        lng: "120.323516"
    }, {
        id: 66388,
        name: "五權國小",
        lat: "22.621166",
        lng: "120.325077"
    }, {
        id: 66389,
        name: "凱旋武昌",
        lat: "22.616885",
        lng: "120.326737"
    }, {
        id: 66390,
        name: "凱旋二聖",
        lat: "22.612557",
        lng: "120.327067"
    }, {
        id: 66391,
        name: "輕軌機廠",
        lat: "22.608484",
        lng: "120.326147"
    }, {
        id: 66338,
        name: "籬仔內",
        lat: "22.6047130",
        lng: "120.324650"
    }, {
        id: 66339,
        name: "凱旋瑞田",
        lat: "22.5991710",
        lng: "120.319388"
    }, {
        id: 66340,
        name: "前鎮之星",
        lat: "22.5930560",
        lng: "120.311667"
    }, {
        id: 66341,
        name: "凱旋中華",
        lat: "22.5936310",
        lng: "120.310519"
    }, {
        id: 66342,
        name: "夢時代",
        lat: "22.5952480",
        lng: "120.304888"
    }, {
        id: 66343,
        name: "經貿園區",
        lat: "22.6009720",
        lng: "120.302633"
    }, {
        id: 66344,
        name: "軟體園區",
        lat: "22.6054420",
        lng: "120.300916"
    }, {
        id: 66345,
        name: "高雄展覽館",
        lat: "22.6100030",
        lng: "120.297732"
    }, {
        id: 66392,
        name: "旅運中心",
        lat: "22.611739",
        lng: "120.293572"
    }, {
        id: 66393,
        name: "光榮碼頭",
        lat: "22.616622",
        lng: "120.293261"
    }, {
        id: 66394,
        name: "真愛碼頭",
        lat: "22.619702",
        lng: "120.289141"
    }, {
        id: 66395,
        name: "駁二大義",
        lat: "22.618672",
        lng: "120.284184"
    }, {
        id: 66396,
        name: "駁二蓬萊",
        lat: "22.620563",
        lng: "120.279914"
    }, {
        id: 66397,
        name: "哈瑪星",
        lat: "22.621554",
        lng: "120.275548"
    }, {
        id: 66398,
        name: "壽山公園",
        lat: "22.626505",
        lng: "120.278766"
    }, {
        id: 66399,
        name: "文武聖殿",
        lat: "22.629704",
        lng: "120.280622"
    }, {
        id: 66400,
        name: "鼓山區公所",
        lat: "22.635951",
        lng: "120.282652"
    }]
}, {
    id: 278,
    name: "機場線",
    lat: "25.0922943",
    lng: "121.2687982",
    child: [{
        id: 4181,
        name: "台北車站",
        lat: "25.0462700",
        lng: "121.5175050"
    }, {
        id: 4213,
        name: "三重",
        lat: "25.0558033",
        lng: "121.4838470"
    }, {
        id: 66317,
        name: "新北產業園區",
        lat: "25.0610671",
        lng: "121.4596494"
    }, {
        id: 66318,
        name: "新莊副都心",
        lat: "25.0595239",
        lng: "121.4465962"
    }, {
        id: 66319,
        name: "泰山",
        lat: "25.0522850",
        lng: "121.4386015"
    }, {
        id: 66320,
        name: "泰山貴和",
        lat: "25.0329510",
        lng: "121.4221587"
    }, {
        id: 66321,
        name: "體育大學",
        lat: "25.0402868",
        lng: "121.3852263"
    }, {
        id: 66335,
        name: "長庚醫院",
        lat: "25.0611263",
        lng: "121.3700473"
    }, {
        id: 66322,
        name: "林口",
        lat: "25.0679191",
        lng: "121.3612459"
    }, {
        id: 66323,
        name: "山鼻",
        lat: "25.0852469",
        lng: "121.2861713"
    }, {
        id: 66324,
        name: "坑口",
        lat: "25.0922943",
        lng: "121.2687982"
    }, {
        id: 66325,
        name: "機場第一航廈",
        lat: "25.0864668",
        lng: "121.2451907"
    }, {
        id: 66326,
        name: "機場第二航廈",
        lat: "25.0759422",
        lng: "121.2325605"
    }, {
        id: 66327,
        name: "機場旅館",
        lat: "25.0686500",
        lng: "121.2207920"
    }, {
        id: 66328,
        name: "大園",
        lat: "25.0607090",
        lng: "121.2104530"
    }, {
        id: 66329,
        name: "橫山",
        lat: "25.0380260",
        lng: "121.2157430"
    }, {
        id: 66330,
        name: "領航",
        lat: "25.0245240",
        lng: "121.2205930"
    }, {
        id: 66331,
        name: "高鐵桃園站",
        lat: "25.0133300",
        lng: "121.2148720"
    }, {
        id: 66332,
        name: "桃園體育園區",
        lat: "25.0014810",
        lng: "121.2031580"
    }, {
        id: 66333,
        name: "興南",
        lat: "24.9802250",
        lng: "121.2161610"
    }, {
        id: 66334,
        name: "環北",
        lat: "24.9670580",
        lng: "121.2210420"
    }]
}, {
    id: 316,
    name: "淡海輕軌",
    lat: "25.1837790",
    lng: "121.4482800",
    child: [{
        id: 4164,
        name: "紅樹林",
        lat: "25.1548020",
        lng: "121.4588300"
    }, {
        id: 66346,
        name: "竿蓁林",
        lat: "25.1597220",
        lng: "121.451944"
    }, {
        id: 66347,
        name: "淡金鄧公",
        lat: "25.1693130",
        lng: "121.460841"
    }, {
        id: 66348,
        name: "淡江大學",
        lat: "25.1757340",
        lng: "121.456770"
    }, {
        id: 66349,
        name: "淡金北新",
        lat: "25.1836110",
        lng: "121.450556"
    }, {
        id: 66350,
        name: "新市一路",
        lat: "25.1837790",
        lng: "121.448280"
    }, {
        id: 66351,
        name: "淡水行政中心",
        lat: "25.1893770",
        lng: "121.443436"
    }, {
        id: 66352,
        name: "濱海義山",
        lat: "25.1901250",
        lng: "121.437532"
    }, {
        id: 66353,
        name: "濱海沙崙",
        lat: "25.1908350",
        lng: "121.431603"
    }, {
        id: 66354,
        name: "淡海新市鎮",
        lat: "25.1944510",
        lng: "121.432256"
    }, {
        id: 66355,
        name: "崁頂",
        lat: "25.2009820",
        lng: "121.434628"
    }, {
        id: 66383,
        name: "台北海洋大學",
        lat: "25.190966",
        lng: "121.426462"
    }, {
        id: 66384,
        name: "沙崙",
        lat: "25.187311",
        lng: "121.417181"
    }, {
        id: 66385,
        name: "淡水漁人碼頭",
        lat: "25.182250",
        lng: "121.418640"
    }]
}, {
    id: 346,
    name: "環狀線",
    lat: "25.0044790",
    lng: "121.4905150",
    child: [{
        id: 4248,
        name: "大坪林",
        lat: "24.9829038",
        lng: "121.5391623"
    }, {
        id: 4306,
        name: "十四張",
        lat: "24.984625",
        lng: "121.527729"
    }, {
        id: 66358,
        name: "秀朗橋",
        lat: "24.990466",
        lng: "121.524989"
    }, {
        id: 66359,
        name: "景平",
        lat: "24.9920701",
        lng: "121.5141418"
    }, {
        id: 4233,
        name: "景安",
        lat: "24.9938633",
        lng: "121.5025998"
    }, {
        id: 66360,
        name: "中和",
        lat: "25.002556",
        lng: "121.495611"
    }, {
        id: 66361,
        name: "橋和",
        lat: "25.004479",
        lng: "121.490515"
    }, {
        id: 66362,
        name: "中原",
        lat: "25.008345",
        lng: "121.484494"
    }, {
        id: 4299,
        name: "板新",
        lat: "25.014702",
        lng: "121.472552"
    }, {
        id: 4298,
        name: "板橋",
        lat: "25.015478",
        lng: "121.464620"
    }, {
        id: 66363,
        name: "新埔民生",
        lat: "25.026311",
        lng: "121.466642"
    }, {
        id: 4211,
        name: "頭前庄",
        lat: "25.0398568",
        lng: "121.4583356"
    }, {
        id: 66364,
        name: "幸福",
        lat: "25.050246",
        lng: "121.459971"
    }, {
        id: 66365,
        name: "新北產業園區",
        lat: "25.0615991",
        lng: "121.4572774"
    }]
}, {
    id: 361,
    name: "台中綠線",
    lat: "24.1611130",
    lng: "120.6487510",
    child: [{
        id: 66366,
        name: "北屯總站",
        lat: "24.188722",
        lng: "120.707287"
    }, {
        id: 66367,
        name: "舊社",
        lat: "24.182262",
        lng: "120.706814"
    }, {
        id: 66368,
        name: "松竹",
        lat: "24.182562",
        lng: "120.701369"
    }, {
        id: 66369,
        name: "四維國小",
        lat: "24.170945",
        lng: "120.696549"
    }, {
        id: 66370,
        name: "文心崇德",
        lat: "24.172589",
        lng: "120.684751"
    }, {
        id: 66371,
        name: "文心中清",
        lat: "24.174127",
        lng: "120.670859"
    }, {
        id: 66372,
        name: "文華高中",
        lat: "24.171596",
        lng: "120.659561"
    }, {
        id: 66373,
        name: "文心櫻花",
        lat: "24.167521",
        lng: "120.653283"
    }, {
        id: 66374,
        name: "市政府",
        lat: "24.161113",
        lng: "120.648751"
    }, {
        id: 66375,
        name: "水安宮",
        lat: "24.152871",
        lng: "120.646636"
    }, {
        id: 66376,
        name: "文心森林公園",
        lat: "24.146614",
        lng: "120.646532"
    }, {
        id: 66377,
        name: "南屯",
        lat: "24.139912",
        lng: "120.646465"
    }, {
        id: 66378,
        name: "豐樂公園",
        lat: "24.134018",
        lng: "120.646626"
    }, {
        id: 66379,
        name: "大慶",
        lat: "24.119939",
        lng: "120.648896"
    }, {
        id: 66380,
        name: "九張犁",
        lat: "24.115038",
        lng: "120.640422"
    }, {
        id: 66381,
        name: "九德",
        lat: "24.111224",
        lng: "120.634310"
    }, {
        id: 66382,
        name: "烏日",
        lat: "24.109151",
        lng: "120.622536"
    }, {
        id: 4383,
        name: "高鐵台中站",
        lat: "24.110042",
        lng: "120.614200"
    }]
}];

const METRO_MAP: MetroMap[] = [{
    regionName: "台北市",
    regionId: 1,
    metroLineIds: [100, 125, 195, 148]
}, {
    regionName: "新北市",
    regionId: 3,
    metroLineIds: [192, 162, 168, 316, 346]
}, {
    regionName: "高雄市",
    regionId: 17,
    metroLineIds: [238, 263, 307]
}, {
    regionName: "桃園市",
    regionId: 6,
    metroLineIds: [278]
}, {
    regionName: "台中市",
    regionId: 8,
    metroLineIds: [361]
}];

export function getMetroList(state: State): FilterOption[] {
    const { region } = state;
    const key = "station";
    const metroLineIds = METRO_MAP.find(metroLine => metroLine.regionId.toString() === region)?.metroLineIds;
    if (!metroLineIds)
        return [];
    return METRO.filter(metro => metroLineIds.includes(metro.id))
        .map(metro => ({
            id: metro.id.toString(),
            key: "metro",
            name: metro.name,
            child: getFilterAllOption(key).concat(metro.child.map( child => ({
                id: child.id.toString(),
                key: key,
                name: child.name
            })))
        }));
}